import React from 'react';
import Text from './SectionCompletedExamples.jsx';
import MCard from '../../../components/MDBCard/MDBCard.jsx';
import Loading from "../../../components/Loading/Loading.jsx";
import getFileData from "../../../APICall/Api.jsx";

class SectionServices extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            items: [],
            url: getFileData
        };
    }

    callAPI = (lang)=>{
        fetch(`${this.state.url.getFileData}/Services${lang.capitalize()}.json`,
            { method: 'get', headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }) }
        )
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        items: result.services
                    });
                },
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error: error
                    });
                }
            )
    }

    componentDidMount() {
        setTimeout(
            function () {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            700
        );
        this.callAPI(this.props.lang)
    }

    componentWillReceiveProps(newProps){
        this.callAPI(newProps.lang)
    }

    render() {
        if (this.state.error) {
            return <div>Error: {this.state.error.message}</div>;
        } else if (!this.state.isLoaded) {
            return <Loading />;
        } else {
            return (
                <div>
                    <Text services={this.props.services} servicesExpr={this.props.servicesExpr} />
                        <MCard cards={this.state.items} servicesButton={this.props.servicesButton} />
                </div>
            );
        }
    }
}

export default SectionServices;


// WEBPACK FOOTER //
// ./src/views/Components/Sections/SectionServices.jsx